// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,

  // buyUrl : "https://1.envato.market/6NV1b",
  SCARF_ANALYTICS : false,
  // adminRoot: '/APP',
  // errorRoot: '/APP/blank-page',
  // loginURL: '/user/login',
  // live
  apiURL: "https://api-crm.bizsoft.app/api/",
  "api-CRM": "https://api-crm.bizsoft.app/api/",

   //apiURL: "https://api-fmis.bizsoft.app/api/",
 // "api-CRM": "https://localhost:44368/api/",
  //apiUrl:  'https://localhost:44368/api/', 
  // local
  //apiURL: "https://localhost:44368/api/",
 



};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
